import { NativeClientService } from '@shared/services/native-client.service';
import { AfterViewInit, Component, computed, inject } from '@angular/core';
import { AppInitService } from './app.init';
import { waitForDOMelement } from '@shared/helpers/observer.helpers';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  private nativeService = inject(NativeClientService);
  private appInitService = inject(AppInitService);

  public title = 'Curamenta';
  public isNative: boolean;
  public location;
  public token;

  protected loading = computed(() => this.appInitService.appLoadingState());

  ngOnInit(): void {
    this.isNative = this.nativeService.isNative;
  }

  ngAfterViewInit(): void {
    // Is necessary for apps
    if (this.nativeService.isNative) {
      waitForDOMelement('.sidenav-switcher').then((elem) => {
        (elem as HTMLElement).click();
      });
    }
  }
}
